import { render } from "./StayPayment.vue?vue&type=template&id=2685cedb&scoped=true"
import script from "./StayPayment.vue?vue&type=script&lang=js"
export * from "./StayPayment.vue?vue&type=script&lang=js"

import "@/shared/css/payment.css?vue&type=style&index=0&lang=css&external"
import "./StayPayment.vue?vue&type=style&index=1&id=2685cedb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2685cedb"]])

export default __exports__